// Modules
import type {GetStaticProps} from 'next';
import {useTranslation} from '@app/hooks/use-translation';
import {serverSideTranslations} from '@app/modules/locale-management/server';
import {LandingSections} from '@tempo/landing';
import {
	FAQ,
	SongcatcherHero,
	SongcatcherName,
	SongcatcherTap,
	SongcatcherSong,
	SongcatcherPower,
	SongcatcherLive,
	SongcatcherMore,
} from '@app/views/features/songcatcher';
import {TempoLandingPage} from '@app/components/layout/LandingPage';
import type {LandingProps} from '@app/types/next';
import {getFooterLinksPerLang} from '@app/modules/ssg-data/unlogged-data';

const SongcatcherPage: React.FC<LandingProps> = () => {
	const {t} = useTranslation();
	const pageTitle = t('songcatcherlandingpage_text_seotitle_standalone-web', {
		ns: 'songcatcher',
	});
	const pageDescription = t(
		'songcatcherlandingpage_text_seodescription_standalone-web',
		{
			ns: 'songcatcher',
		},
	);
	return (
		<TempoLandingPage title={pageTitle} description={pageDescription}>
			<LandingSections topGutter>
				<SongcatcherHero />
				<SongcatcherName />
				<SongcatcherMore />
				<SongcatcherTap />
				<SongcatcherSong />
				<SongcatcherPower />
				<SongcatcherLive />
				<FAQ />
			</LandingSections>
		</TempoLandingPage>
	);
};

export const getStaticProps: GetStaticProps<LandingProps> = async ({
	locale = '',
	locales = [],
}) => {
	const translations = await serverSideTranslations(locale, [
		'songcatcher',
		'common',
	]);
	return {
		props: {
			...translations,
			dehydratedState: {
				...(await getFooterLinksPerLang({locale, locales})),
			},
			tracking: {
				pagecategory: 'features',
				pagename: 'songcatcher',
				cdpViewId: 'features_songcatcher',
			},
		},
		revalidate: 15 * 60,
	};
};

export default SongcatcherPage;
